
import firebase, {
    getHelpCommunityData,
    getListQuestions,
    getMoreAnsweredQuestions,
    getListAnswers,
    getAllQuestions,
    firestore,
} from '../../configs/environments/firebase/firebaseApp'

export const GET_HELPSECTION_DATA = 'GET_HELPSECTION_DATA';
export const SET_COMMUNITY_KEY = 'SET_COMMUNITY_KEY';
export const GET_LIST_QUESTION = 'GET_LIST_QUESTION';
export const GET_ALL_QUESTION = 'GET_ALL_QUESTION';
export const GET_MORE_ANSWERED_QUESTION = 'GET_MORE_ANSWERED_QUESTION';
export const GET_MORE_ANSWERS = 'GET_MORE_ANSWERS';
export const UPDATE_LIKES = 'UPDATE_LIKES';

const getHelpingData = data => {
    return {
        type: GET_HELPSECTION_DATA,
        data
    }
}

const settingCommunityKey = (data) => {
    return {
        type: SET_COMMUNITY_KEY,
        data
    }
}

const questionPagesLoad = (data) => {
    return {
        type: GET_LIST_QUESTION,
        data
    }
}

const questionPagingLoad = (data) => {
    return {
        type: GET_ALL_QUESTION,
        data
    }
}

const moreAnsweredQuestionPagesLoad = (data) => {
    return {
        type: GET_MORE_ANSWERED_QUESTION,
        data
    }
}

const moreAnswersLoad = (data) => {
    return {
        type: GET_MORE_ANSWERS,
        data
    }
}

const updatingLikes = (data) => {
    return {
        type: UPDATE_LIKES,
        data
    }
}

export const getHelpSectionData = () => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await getHelpCommunityData()
            dispatch(getHelpingData(response.data))
            return resolve(response.data);
        } catch (error) {
            return reject(error);
        }
    })
}

export const setCommunityKey = searchKey => dispatch => {
    dispatch(settingCommunityKey(searchKey))
}

export const pagingQuestion = (search, page) => (dispatch) => {
    process_question_page(dispatch, search, page)
}

export const pagingAllQuestions = (page) => (dispatch) => {
    process_paging_allQuestions(dispatch, page)
}

export const updatePagingQuestion = (search, page) => (dispatch) =>{
    process_question_page(dispatch, search, page)
}

export const moreQuestion = () => (dispatch) =>{
    process_more_question(dispatch)
}

export const getAnswers = (id, page) => (dispatch) => {
    process_list_answer(dispatch, id, page)
}

export const updateLike = (
    clientUid,
    lawyerUid,
    likeStatus,
    questionId,
    answerId,
    likesArray,
    responseArray,
    item,
    like,
    oldGotLikes
) => (dispatch) => {
    return new Promise(async (resolve, reject) => {

        // Pasa el nuevo array de likes a firebase en la colección questions
        let filteredLikes = []
        if (Array.isArray(likesArray)) {
            filteredLikes = likesArray.filter(elem => {
                return elem.clientUid !== clientUid
            })
        }
        const likeStruct = {
            util: likeStatus,
            clientUid,
            lawyerUid
        }
        filteredLikes.push(likeStruct)

        // Prepara el response completo para pasar a redux con likes actualizados
        let response = responseArray
        const indexResponseToEdit = response.findIndex(elem => elem.id === answerId)
        response[indexResponseToEdit] = {
            ...response[indexResponseToEdit],
            likes: filteredLikes,
        }

        // Contador de like hacia el abogado en redux
        const calculateGotLikes = (responseArray, type) => {
            responseArray.forEach(elem => {
                if (elem.lawyerUsers.uid === lawyerUid) {
                    elem['lawyerUsers'] = {
                        ...elem.lawyerUsers,
                            gotLikes:
                                type === 'increase' && oldGotLikes ?
                                oldGotLikes + 1 :
                                type === 'increase' && likesArray ?
                                elem.lawyerUsers.gotLikes + 1 :
                                type === 'increase' ?
                                1 :
                                type === 'decrease' && like ?
                                elem.lawyerUsers.gotLikes - 1 :
                                type === 'decrease' ?
                                elem.lawyerUsers.gotLikes :
                                type === 'nothing' && like ?
                                elem.lawyerUsers.gotLikes - 1 :
                                type === 'nothing' ?
                                elem.lawyerUsers.gotLikes :
                                elem.lawyerUsers.gotLikes
                    }
                }
            })
            return responseArray
        }

        // Contador de like hacia el abogado en firebase
        let increment
        let type
        switch (item) {
            case 'like':
                if (oldGotLikes) {
                    increment = firebase.firestore.FieldValue.increment(1)
                } else if (likesArray) {
                    increment = firebase.firestore.FieldValue.increment(1)
                } else {
                    increment = 1
                }
                type = 'increase'
                break;
            case 'dislike':
                if (like) {
                    increment = firebase.firestore.FieldValue.increment(-1)
                    type = 'decrease'
                } else {
                    increment = firebase.firestore.FieldValue.increment(0)
                    type = 'nothing'
                }
                break;
            default:
                if (like) {
                    increment = firebase.firestore.FieldValue.increment(-1)
                    type = 'decrease'
                } else {
                    increment = firebase.firestore.FieldValue.increment(0)
                    type = 'nothing'
                }
                break;
        }
        
        const newResponse = calculateGotLikes(response, type)
        
        try {
            await firestore
                .collection('questions')
                .doc(questionId)
                .collection('response')
                .doc(answerId)
                .set({
                    likes: filteredLikes
                }, { merge: true })
            await firestore
                .collection('lawyerUsers')
                .doc(lawyerUid)
                .set({
                    gotLikes: increment
                }, { merge: true })
            dispatch(updatingLikes(newResponse))
            return resolve(response);
        } catch (error) {
            reject(error)
        }
    });
}

async function process_question_page (dispatch, search, page){
    try {
        let question = await getListQuestions(search, page)
        dispatch(questionPagesLoad(question));
    } catch (error) {
        throw error;
    }
}

async function process_paging_allQuestions (dispatch, page){
    try {
        let questions = await getAllQuestions(page)
        dispatch(questionPagingLoad(questions));
    } catch (error) {
        throw error;
    }
}

async function process_more_question (dispatch){
    try {
        let moreQuestion = await getMoreAnsweredQuestions();
        dispatch(moreAnsweredQuestionPagesLoad(moreQuestion.data));
    } catch (error) {
        throw error;
    }
}

async function process_list_answer(dispatch, id, page) {
    try {
        const response = await getListAnswers(id, page);
        dispatch(moreAnswersLoad(response))
    } catch (error) {
        throw error;
    }
}
